import PropTypes from 'prop-types';
import React from 'react';

export const numberOrString = PropTypes.oneOfType([
  PropTypes.string,
  PropTypes.number,
]);
